import { LogoutOutlined, SettingOutlined } from '@ant-design/icons';

const settings = {
  id: 'group-settings',
  title: 'Settings',
  type: 'group',
  children: [
    {
      id: 'settings',
      title: 'Settings',
      type: 'item',
      url: '/account/settings',
      icon: SettingOutlined
    },
    {
      id: 'logout',
      title: 'LogOut',
      type: 'item',
      url: '/account/logout',
      icon: LogoutOutlined
    }
  ]
};

export default settings;
